var map = {
  "./cs-CZ/dashboardTranslation.json": "PG",
  "./da-DK/dashboardTranslation.json": "s1",
  "./de-DE/dashboardTranslation.json": "iG",
  "./en-GB/dashboardTranslation.json": "Ti",
  "./en-US/dashboardTranslation.json": "DG",
  "./es-ES/dashboardTranslation.json": "yJ",
  "./fi-FI/dashboardTranslation.json": "nD",
  "./it-IT/dashboardTranslation.json": "d2",
  "./pl-PL/dashboardTranslation.json": "ZX",
  "./pt-PT/dashboardTranslation.json": "Ts",
  "./sv-SE/dashboardTranslation.json": "vD"
};


function __rspack_context_module(req) {
  var id = __rspack_context_module_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_module_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context_module.keys = function() { return Object.keys(map); };
__rspack_context_module.resolve = __rspack_context_module_resolve;
module.exports = __rspack_context_module;
__rspack_context_module.id = "D4";
